import { stringify } from "query-string";
import {
  GET_LIST,
  GET_ONE,
  GET_MANY,
  GET_MANY_REFERENCE,
  CREATE,
  UPDATE,
  DELETE,
  DELETE_MANY
} from "react-admin";
import { auth } from "../../firebase";
import { QA_API_ERROR } from "../../util";

const QuestionProvider = opt => {
  const { config, httpClient } = opt;
  if (!config) {
    throw new Error("Missing config");
  }
  if (!httpClient) {
    throw new Error("Missing httpClient");
  }
  const provider = {
    handle(type, params) {
      switch (type) {
        case GET_LIST:
          return provider.list(params);
        case GET_ONE:
          return provider.get(params);
        case GET_MANY:
          return provider.getMany(params);
        case GET_MANY_REFERENCE:
          return provider.list(params);
        case CREATE:
          return provider.create(params);
        case UPDATE:
          return provider.update(params);
        case DELETE:
          return provider.delete(params);
        case DELETE_MANY:
          return provider.deleteMany(params);
        default:
          throw new Error(`QuestionProvider unsupported action type: ${type}`);
      }
    },
    get(params) {
      return httpClient
        .get(`/api/question/${params.id}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("QuestionProvider.get Error", result, params);
          }
          let response = {
            data: result.question
          };
          return response;
        });
    },
    getMany(params) {
      const query = {
        ids: params.ids
      };
      return httpClient
        .get(`/api/admin/questions?${stringify(query)}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR(
              "QuestionProvider.getMany Error",
              result,
              params
            );
          }
          const response = {
            data: result.questions || null
          };
          return response;
        });
    },
    list(params) {
      const query = {
        order: params.sort.field,
        sort: params.sort.order.toLowerCase(),
        limit: params.pagination.perPage
      };
      // target
      if (params.target === "boardId") {
        query.boardId = params.id;
      }
      if (params.target === "authorId") {
        query.authorId = params.id;
      }
      // filter
      if (params.filter.board && params.filter.board.id) {
        query.boardId = params.filter.board.id;
      }
      if (params.filter.author) {
        query.authorId = params.filter.author.id;
      }
      // pagination
      if (typeof params.pagination.page === "string") {
        const [pageNumber, afterOrBefore, id] = params.pagination.page.split(
          "_"
        );
        if (afterOrBefore === "after") {
          query.after = id;
        } else if (afterOrBefore === "before") {
          query.before = id;
        }
        console.log("pageNumber: ", pageNumber);
      }
      return httpClient
        .get(`/api/admin/questions?${stringify(query)}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("QuestionProvider.list Error", result, params);
          }
          const response = {
            data: result.questions || null,
            total: 1000
          };
          if (!response.data) {
            response.total = 0;
          }
          return response;
        });
    },
    create(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token,
            title: params.data.title,
            boardId: params.data.boardId,
            authorId: params.data.authorId
          };
          if (params.data.tag) {
            payload.tags = [params.data.tag];
          }
          if (params.data.content) {
            payload.content = params.data.content;
          }
          if (params.data.images && params.data.images.length) {
            payload.images = params.data.images;
          }
          if (params.data.publishDate) {
            payload.publishDate = params.data.publishDate.toISOString();
          }
          return httpClient.post(`/api/admin/questions`, payload);
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("QuestionProvider.create Error", result, params);
          }
          const response = {
            data: result.question
          };
          return response;
        });
    },
    update(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token,
            title: params.data.title || null,
            content: params.data.content.text || null,
            images: params.data.content.images || null,
            time: params.data.time || null,
            status: params.data.status || null
          };
          if (params.data.tag) {
            payload.tags = [params.data.tag];
          }
          return httpClient.put(`/api/admin/question/${params.id}`, payload);
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("QuestionProvider.update Error", result, params);
          }
          const response = {
            data: result.question
          };
          return response;
        });
    },
    delete(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token
          };
          return httpClient.delete(`/api/admin/question/${params.id}`, {
            data: payload
          });
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("QuestionProvider.delete Error", result, params);
          }
          const response = {
            data: result.question
          };
          return response;
        });
    },
    deleteMany(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          const payload = {
            token,
            ids: params.ids
          };
          return httpClient.delete(`/api/admin/questions`, { data: payload });
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR(
              "QuestionProvider.deleteMany Error",
              result,
              params
            );
          }
          const response = {
            data: result.deletedIds
          };
          return response;
        });
    }
  };
  return provider;
};

export default QuestionProvider;
